module.exports = __webpack_public_path__ + "img/542.57fc55f1.jpg";